import React from "react";
import { FiX } from "react-icons/fi";

// Modal shown when the sandbox wants to send data outbound. The user chooses
// allow-once / allow-always (persisted to localStorage whitelist) / deny.
export default function NetworkConfirmModal({ request, texts, onDecide }) {
  if (!request) return null;
  const t = texts && texts.network ? texts.network : null;
  const L = {
    title: (t && t.confirmTitle) || "外部へのデータ送信を検出しました",
    subtitle: (t && t.confirmSubtitle) || "このリクエストを許可しますか？",
    method: (t && t.method) || "メソッド",
    url: (t && t.url) || "送信先",
    body: (t && t.bodyLabel) || "Body (先頭)",
    once: (t && t.allowOnce) || "今回のみ許可",
    always: (t && t.allowAlways) || "常に許可",
    deny: (t && t.deny) || "拒否",
    close: (t && t.closeAria) || "閉じる"
  };

  const bodyPreview = request.body ? String(request.body).slice(0, 200) : null;

  return (
    <div className="ncm-overlay" role="dialog" aria-modal="true">
      <div className="ncm-modal">
        <button className="ncm-close" aria-label={L.close} onClick={() => onDecide("deny")}>
          <FiX />
        </button>
        <h3 className="ncm-title">{L.title}</h3>
        <p className="ncm-subtitle">{L.subtitle}</p>
        <dl className="ncm-fields">
          <div className="ncm-field">
            <dt>{L.method}</dt>
            <dd><span className="ncm-method">{request.method || "—"}</span></dd>
          </div>
          <div className="ncm-field">
            <dt>{L.url}</dt>
            <dd className="ncm-url" title={request.url}>{request.url || "—"}</dd>
          </div>
          {bodyPreview && (
            <div className="ncm-field">
              <dt>{L.body}</dt>
              <dd><pre className="ncm-body">{bodyPreview}</pre></dd>
            </div>
          )}
        </dl>
        <div className="ncm-actions">
          <button className="ncm-btn ncm-once" onClick={() => onDecide("allow-once")}>{L.once}</button>
          <button className="ncm-btn ncm-always" onClick={() => onDecide("allow-always")}>{L.always}</button>
          <button className="ncm-btn ncm-deny" onClick={() => onDecide("deny")}>{L.deny}</button>
        </div>
      </div>
    </div>
  );
}